import * as React from 'react';
import { Stack } from '@fluentui/react';

interface IPageTitleProps {
    title: string;
}


export const PageTitle: React.FunctionComponent<IPageTitleProps> = (props) => {

   return (
        <Stack styles={{ root: { paddingTop: 40, textAlign: "center"}}}>
            <h1 style={{ textAlign: "center" }}>{props.title}</h1>
            <Stack horizontal>
                <Stack grow styles={{ root: { height: 8, backgroundColor: "#f2cd24" } }}></Stack>
                <Stack grow styles={{ root: { height: 8, backgroundColor: "#c2d465" } }}></Stack>
                <Stack grow styles={{ root: { height: 8, backgroundColor: "#007dad" } }}></Stack>
                <Stack grow styles={{ root: { height: 8, backgroundColor: "#b7542c" } }}></Stack>
            </Stack>
        </Stack>
        )
}
